import { forwardRef, useImperativeHandle } from "react";
import FormInputText from "../components/Form/FormInputText";
import { ComplainStatus } from "../models/complain.model";
import { useForm } from "react-hook-form";

export const CloseComplainForm = forwardRef(
  (props: { helperText: string; nextStatus: ComplainStatus }, ref) => {
    const { control, setError, handleSubmit } = useForm();

    useImperativeHandle(ref, () => ({
      onSubmit: async () => {
        return new Promise((resolve, reject) => {
          handleSubmit(resolve, reject)();
        });
      },
    }));

    return (
      <div>
        <div>{props.helperText}</div>
        {props.nextStatus === ComplainStatus.closed && (
          <div style={{ marginTop: 16 }}>
            <FormInputText
              name="details"
              label="Resolution Details"
              required
              rules={{
                required: "Resolution details are required to close a complain",
              }}
              control={control}
              setError={setError}
              multiline
              rows={3}
            />
          </div>
        )}
      </div>
    );
  }
);
